import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button } from '@mui/material';
import TitleUser from '~/components/TitleUser';
import { Link } from 'react-router-dom';
import Pagination from '~/components/Pagination';
import images from '~/assets/images';
import classNames from 'classnames/bind';
import styles from './MySocialMemoryPrint.module.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import slugify from 'slugify';
import { socialMemoryPrint } from '~/Store/Action/bookActions';

const cx = classNames.bind(styles);

const MySocialMemoryPrint = () => {
    const dispatch = useDispatch();
    const [user, setUser] = useState(null);
    let navigate = useNavigate();

    const auth = useSelector((state) => state.auth);

    const listSocialPrint = useSelector((state) => state?.book?.listSocialPrint?.data?.data);

    useEffect(() => {
        if (auth.user) {
            setUser(JSON.parse(auth.user));
        }
    }, [auth]);

    useEffect(() => {
        dispatch(socialMemoryPrint(auth.token, JSON.parse(auth.user).id));
    }, []);

    const handleRedirect = () => {
        navigate('/tai-khoan/quan-ly-ky-uc-xa-hoi-sach-giay/them-moi-sach');
    };

    return (
        <Box className={cx('MySocialMemoryPrint')}>
            <div className={cx('title-user')}>
                <TitleUser title="Quản lý kí ức xã hội giấy" />
                <Button onClick={handleRedirect}>Thêm mới</Button>
            </div>
            <div className="row">
                {listSocialPrint?.length > 0 ? (
                    listSocialPrint?.map((item, index) => (
                        <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4">
                            <div className="wow animate__animated animate__flipInY">
                                <div className="card card-hover">
                                    <Link
                                        className="w-100"
                                        to={'/sach-giay/' + slugify(item.name) + '/' + item.id}
                                    >
                                        <LazyLoadImage
                                            src={item?.image}
                                            style={{ height: '144px' }}
                                            effect="blur"
                                            className="card-img-top"
                                            alt="Image Alt"
                                        />
                                    </Link>
                                    <div className="card-body" style={{ paddingBottom: 0 }}>
                                        <Link className="w-100" to={'/sach-giay/' + slugify(item.name) + '/' + item.id}>
                                            <p
                                                className="card-title text-dark fw-bold"
                                                style={{
                                                    fontFamily: 'sans-serif',
                                                    height: '50px',
                                                    textDecoration: 'none',
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: 'vertical',
                                                    display: '-webkit-box',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                {item?.name}
                                            </p>
                                        </Link>
                                        <div className="d-flex align-items-center">
                                            <span className="fs-4" style={{ color: 'rgba(39, 171, 96, 1)' }}>
                                                Doanh thu {item?.revenue}đ
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className="card-footer"
                                        style={{ background: '#ffffff', border: 'none', padding: '14px 10px' }}
                                    >
                                        <div className="d-flex justify-content-between">
                                            <span className="text-dark fs-5">{item?.view} đã học</span>
                                            <span className="text-dark fs-5">
                                                {item?.opening_date
                                                    ? format(new Date(item?.opening_date), 'dd/M/yyyy')
                                                    : ''}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <h2>Hiện tại không có kí ức xã hội nào!</h2>
                )}
            </div>
        </Box>
    );
};

export default MySocialMemoryPrint;
